// You can write more code here

/* START OF COMPILED CODE */

import ProgressBarWithCheckbox from '../GeneralUI/ProgressBarWithCheckbox';
/* START-USER-IMPORTS */
import { DailyType } from '@/common/types/game';
import { getDailies } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
/* END-USER-IMPORTS */

export default class DailyActivityUI extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // mobileView
    const mobileView = scene.add.container(0, 0);
    this.add(mobileView);

    // dailyText_m
    const dailyText_m = scene.add.bitmapText(
      40,
      16,
      'Aronui',
      'Daily Activity',
    );
    dailyText_m.setOrigin(0, 0.5);
    dailyText_m.tintTopLeft = 5387071;
    dailyText_m.tintTopRight = 5387071;
    dailyText_m.tintBottomLeft = 5387071;
    dailyText_m.tintBottomRight = 5387071;
    dailyText_m.text = 'Daily Activity';
    dailyText_m.fontSize = -22;
    mobileView.add(dailyText_m);

    // gemContainer_m
    const gemContainer_m = scene.add.container(260, 16);
    mobileView.add(gemContainer_m);

    // gemBacking_m
    const gemBacking_m = scene.add.nineslice(
      0,
      0,
      'backingFadeOut_m',
      undefined,
      30,
      16,
      1,
      3,
      1,
      1,
    );
    gemBacking_m.scaleX = 2;
    gemBacking_m.scaleY = 2;
    gemBacking_m.setOrigin(0, 0.5);
    gemContainer_m.add(gemBacking_m);

    // dailyRewardIcon_m
    const dailyRewardIcon_m = scene.add.image(0, 0, 'hud-icons', 95);
    dailyRewardIcon_m.scaleX = 2;
    dailyRewardIcon_m.scaleY = 2;
    gemContainer_m.add(dailyRewardIcon_m);

    // dailyRewardValue_m
    const dailyRewardValue_m = scene.add.bitmapText(16, 0, 'Aronui', '50');
    dailyRewardValue_m.setOrigin(0, 0.5);
    dailyRewardValue_m.tintTopLeft = 15130076;
    dailyRewardValue_m.tintTopRight = 15130076;
    dailyRewardValue_m.tintBottomLeft = 15130076;
    dailyRewardValue_m.tintBottomRight = 15130076;
    dailyRewardValue_m.text = '50';
    dailyRewardValue_m.fontSize = -20;
    gemContainer_m.add(dailyRewardValue_m);

    // progressBarWithCheckbox_m
    const progressBarWithCheckbox_m = new ProgressBarWithCheckbox(scene, 0, 48);
    mobileView.add(progressBarWithCheckbox_m);

    // desktopView
    const desktopView = scene.add.container(0, 0);
    desktopView.visible = false;
    this.add(desktopView);

    // dailyText
    const dailyText = scene.add.bitmapText(40, 16, 'Aronui', 'Daily Activity');
    dailyText.setOrigin(0, 0.5);
    dailyText.tintTopLeft = 5387071;
    dailyText.tintTopRight = 5387071;
    dailyText.tintBottomLeft = 5387071;
    dailyText.tintBottomRight = 5387071;
    dailyText.text = 'Daily Activity';
    dailyText.fontSize = -22;
    desktopView.add(dailyText);

    // gemContainer
    const gemContainer = scene.add.container(260, 16);
    desktopView.add(gemContainer);

    // gemBacking
    const gemBacking = scene.add.nineslice(
      0,
      0,
      'backingFadeOut',
      undefined,
      15,
      8,
      1,
      3,
      1,
      1,
    );
    gemBacking.scaleX = 4;
    gemBacking.scaleY = 4;
    gemBacking.setOrigin(0, 0.5);
    gemContainer.add(gemBacking);

    // dailyRewardIcon
    const dailyRewardIcon = scene.add.image(0, 0, 'ruby-small');
    dailyRewardIcon.scaleX = 4;
    dailyRewardIcon.scaleY = 4;
    gemContainer.add(dailyRewardIcon);

    // dailyRewardValue
    const dailyRewardValue = scene.add.bitmapText(16, 0, 'Aronui', '50');
    dailyRewardValue.setOrigin(0, 0.5);
    dailyRewardValue.tintTopLeft = 15130076;
    dailyRewardValue.tintTopRight = 15130076;
    dailyRewardValue.tintBottomLeft = 15130076;
    dailyRewardValue.tintBottomRight = 15130076;
    dailyRewardValue.text = '50';
    dailyRewardValue.fontSize = -24;
    gemContainer.add(dailyRewardValue);

    // progressBarWithCheckbox
    const progressBarWithCheckbox = new ProgressBarWithCheckbox(scene, 0, 48);
    desktopView.add(progressBarWithCheckbox);

    this.dailyText_m = dailyText_m;
    this.dailyRewardValue_m = dailyRewardValue_m;
    this.progressBarWithCheckbox_m = progressBarWithCheckbox_m;
    this.mobileView = mobileView;
    this.dailyText = dailyText;
    this.dailyRewardValue = dailyRewardValue;
    this.progressBarWithCheckbox = progressBarWithCheckbox;
    this.desktopView = desktopView;

    /* START-USER-CTR-CODE */
    this.initializeResponsiveness();
    /* END-USER-CTR-CODE */
  }

  public dailyText_m: Phaser.GameObjects.BitmapText;
  public dailyRewardValue_m: Phaser.GameObjects.BitmapText;
  public progressBarWithCheckbox_m: ProgressBarWithCheckbox;
  private mobileView: Phaser.GameObjects.Container;
  public dailyText: Phaser.GameObjects.BitmapText;
  public dailyRewardValue: Phaser.GameObjects.BitmapText;
  public progressBarWithCheckbox: ProgressBarWithCheckbox;
  private desktopView: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  getResponsiveElements(key: keyof DailyActivityUI) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  setDailyActivity(reward: DailyType) {
    const dailies = getDailies();
    const dailyName = this.getDailyName(reward);
    this.getResponsiveElements('dailyText').forEach(
      (dailyText: Phaser.GameObjects.BitmapText) => {
        dailyText.text = dailyName;
      },
    );

    this.getResponsiveElements('dailyRewardValue').forEach(
      (dailyRewardValue: Phaser.GameObjects.BitmapText) => {
        dailyRewardValue.text = '50'; // Todo - dynamically generate reward amount.
      },
    );
    if (reward === DailyType.MINIGAME) {
      this.getResponsiveElements('progressBarWithCheckbox').forEach(
        (progressBar: ProgressBarWithCheckbox) => {
          progressBar.brain.setProgressInstant(
            dailies.minigames.numCompletedMinigames /
              dailies.minigames.targetNumMinigames,
          );
        },
      );

      this.getResponsiveElements('dailyRewardValue').forEach(
        (dailyRewardValue: Phaser.GameObjects.BitmapText) => {
          dailyRewardValue.setAlpha(
            dailies.minigames.numCompletedMinigames >=
              dailies.minigames.targetNumMinigames
              ? 0.5
              : 1,
          );
        },
      );
    } else if (reward === DailyType.DUEL) {
      this.getResponsiveElements('progressBarWithCheckbox').forEach(
        (progressBar: ProgressBarWithCheckbox) => {
          progressBar.brain.setProgressInstant(
            dailies.duel.hasCompletedDuel ? 1 : 0,
          );
        },
      );

      this.getResponsiveElements('dailyRewardValue').forEach(
        (dailyRewardValue: Phaser.GameObjects.BitmapText) => {
          dailyRewardValue.setAlpha(dailies.duel.hasCompletedDuel ? 0.5 : 1);
        },
      );
    }
  }

  getDailyName(dailyType: string) {
    const dailies = getDailies();
    switch (dailyType) {
      case 'minigame':
        return `Play ${dailies.minigames.targetNumMinigames} minigames`;
      case 'duel':
        return `Win a duel`;
      default:
        return '<undefined daily>';
    }
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
